/** Partes de los mensajes de error de la Caja Fuerte que se pueden mostrar al usuario tal como vienen. */
const SAFE_VAULT_MESSAGES = [
  'PIN requerido',
  'PIN inválido',
  'organizacionId requerido',
  'Cliente no encontrado',
  // The server's encryption key does not match the vault control value.
  'La Caja Fuerte no está disponible',
  // Rol o cartera sin acceso (vault-claves, utils/acceso-claves.ts).
  'Tu rol no puede',
  // Rechazos de las funciones de la clave fiscal de una inscripción.
  'no se pueden pasar porque',
  'no se puede guardar porque',
]

/** El mensaje del error si es uno de los que se pueden mostrar; si no, `fallback`. */
export const sanitizeVaultError = (err: unknown, fallback: string): string => {
  if (!(err instanceof Error)) return fallback
  const msg = err.message
  if (SAFE_VAULT_MESSAGES.some((safe) => msg.includes(safe))) return msg
  return fallback
}

/** Organismos de las claves de la Caja Fuerte. «Otro» abre un texto libre. */
export const ORGANISMOS = [
  'AFIP / ARCA',
  'AGIP',
  'ARBA',
  'DGR Tucumán',
  'API Santa Fe',
  'DGR Misiones',
  'ATM Mendoza',
  'DGR Córdoba',
  'Otro',
]
